<template>
<div class="avia-flight-out">
    <nav class="avia-flight-out-header">
       <span @click="toBasket()" class="to-basket">
        {{localizeList.toCart}}
       </span>
       
      <div class="align-center">
        <div class="align-center">
          <div class="sort-title mr-5">{{localizeList.textSortUpperTitleUpper}}:</div>
          <div v-for="(item, key) in sortItems"
               :key="key"
               class="sort-item mr-5">
            <radio-btn :value="item.isChecked"
                       @change="changeSort(key)">
              {{localizeList[item.name]}}
            </radio-btn>
          </div>
        </div>

        <div v-if="!getWindowSettings.showVerticalFilters" @click="openFilters()"
           ref="filterBtn"
           class="filters-wrap pointer">
          <span class="filters-text">{{localizeList.filters}}</span>
          <icon name="filter" width="20px" height="18px" fill="var(--lighten-5-color)" />
        </div>
        
      </div>

      <div
          v-if="getWindowSettings.compactView"
          @click.stop="toggleShowGroupAll()"
          class="show-all-button pointer">
          <span class="show-all-button-text"> {{ showAllFlights ? localizeList.minimizeAllFlights : localizeList.showAllFlights }} </span>
      </div>
      <div v-else></div>
    </nav>
      <div v-show="mainInfoText.length" class="short-info">
        <div class="ml-4">
          <h3 class="short-info-title mb-2"><icon name="flight" width="21px" height="20px" fill="var(--lighten-5-color)" style="display: inline; vertical-align: middle; padding-right: 10px"/>{{mainInfoText}}</h3>
          <p class="short-info-text">{{localizeList.infoBlockPartOne}} {{localizeList.infoBlockPartTwo}}</p>
        </div>
      </div>
      
      <!-- Вертикальные фильтры -->
      <div :class="{'vertical-filters-flights': getWindowSettings.showVerticalFilters }">
        <div v-show="getWindowSettings.showVerticalFilters && getGDS" class="vertical-sidebar">
          <avia-flight-vertical-filters 
                         v-if="getWindowSettings.showVerticalFilters"
                         @filtred="flightFiltration($event)"
                         @changeTariff="getGDSFlights($event)"
                         :set-filters="flightFilters"
                         :city-from="cityFrom"
                         :city-to="cityTo"
                         :is-items-loaded="flightListPresent.length" />
        </div>

      <div v-show="flightListPresent.length" class="avia-flight-group">
        <div v-for="(item, key) in flightListPresent"
             :key="key"
             :class="['avia-flight-item', {'change': item.isChanged}, checkShowGroup(key)]">
          <div class="avia-flight-content-wrap">
              <div v-for="(item2, key2) in item.flights"
                v-show="checkShowGroupByDirection(key, item2.direction) || selectedFlights[key].keys[item2.direction === 'Forward' ? 0 : 1] === key2"
                :key="key2"
                :class="['avia-flight-content',
                {'empty-backward': !hasBackward(item)},
                {'selected': selectedFlights[key].keys[item2.direction === 'Forward' ? 0 : 1] === key2},
                {'forward': item2.direction === 'Forward'},
                {'first-forward': item2.direction === 'Forward' && key2 === 0},
                {'last-forward': item2.direction === 'Forward' && item.flights.length > 1 && item.flights[key2 + 1] && item.flights[key2 + 1].direction === 'Backward'},
                {'first-backward': item2.direction === 'Backward' && item.flights[key2-1].direction === 'Forward'},
                {'backward': item2.direction === 'Backward'},
                {'forward-selected': selectedFlights[key].keys[0] === key2 && showGroup[key].forward},
                {'backward-selected': selectedFlights[key].keys[1] === key2 && showGroup[key].backward},]"
                @click="selectFlightByKey(key, key2, item)"
                >
              <div
                v-show="selectedFlights[key].keys[item2.direction === 'Forward' ? 0 : 1] === key2"
                :class="['color-content',
                {'primary': item2.direction === 'Forward'},
                {'green': item2.direction === 'Backward'}]">
              </div>
              <div class="flex-content">
                  <div :class="['departure-title',
                   {'forwardColor': item2.direction === 'Forward'}, 
                   {'backwardColor': item2.direction === 'Backward'}]"
                  v-if ="key2 === 0 || key2 === item.groupItemsFrom.length
                  || (!showGroup[key].forward && key2 < item.groupItemsFrom.length)
                  || (!showGroup[key].backward && key2 >= item.groupItemsFrom.length)"
                  > 
                      <span> {{ item2.direction === 'Forward' ? localizeList.forward+':' : localizeList.backward+':' }} 
                      {{item2.departureCity}}, {{item2.allSegments[0].departureAirport.mtItem.name}}
                      </span>
                      <span>&#10145;</span>
                      <span>{{item2.arrivalCity}}, {{item2.allSegments.at(-1).arrivalAirport.mtItem.name}}</span>
                  </div>
                  <div class="info-container">
                        <div class="departure-info info-flight">
                          <div class="relative img-wrap">
                            <img v-for="(item3, key3) in item2.airlineServices"
                                :key="key3"
                                :style="[{'left': key3*10 + 'px'}, {'top': key3*5 + 'px'}]"
                                width="30" height="30"
                                class="absolute"
                                :src="`${API_ORIGIN}${PATH}/GetImage/GetImage?type=Airline&id=${item3}&width=50&height=50`"
                                @mouseenter="showPopover(item2.allSegments[key3].airline.mtItem.name, $event)"
                                @mouseleave="hidePopover()"
                                />
                        </div>
                        <div class="flights-number" >
                            <!-- <p class="text-info" @click="getFlightNumberAndCode(item.flights[key2])"></p> -->
                            <p class="nowrap" v-for="(flight, idx) in item.flights[key2].allSegments" :key="idx">
                              {{ flight.airline.mtItem.code + ' ' + flight.flightNumber }}
                            </p>
                         </div>
                        <div class="text-info">
                           <div class="relative">
                              <p class="time">{{item2.departureDate|getTime}}</p>
                              <!--  <p class="progress-flight-time">({{localizeList.travelTimeTitle}}: {{item2.progress.fligthTime}})</p>  -->
                           </div>
                           <!-- <p class="country">{{item2.departureCity}}</p> -->
                           <p class="data">{{item2.departureDate|getDate}}</p>
                        </div>
                  </div>
                <div class="flight-info-content">
                  <avia-flight-info 
                  @showPopover="showPopover"
                  @hidePopover="hidePopover"
                  :flightData="item2"
                  />
                </div>
                  <div class="arrival-info info-flight">
                    <div class="text-info">
                      <p class="time">{{item2.arrivalDate|getTime}}</p>
                      <!-- <p class="country">{{item2.arrivalCity}}</p> -->
                      <p class="data">{{item2.arrivalDate|getDate}}</p>
                    </div>
                    <div class="luggage-info">
                      <div @mouseleave="hidePopover()"
                           @mouseenter="showPopover(item2.luggage.info, $event)"
                           class="mr-4 relative"
                      >
                        <icon name="luggage" width="16px" height="15px" />
                        <span class="luggage-text absolute-center">{{item2.luggage.value}}</span>
                      </div>
                      <div @mouseleave="hidePopover()"
                           @mouseenter="showPopover(item2.bigLuggage.info, $event)"
                           class="mr-4 relative">
                        <icon v-if="item2.luggageType === 'big-luggage-question'"
                              name="big-luggage-question" width="14px" height="24px" />
                        <icon v-else-if="item2.luggageType === 'big-luggage-none'"
                              name="big-luggage-none" width="14px" height="24px" />
                        <icon v-else
                              name="big-luggage" width="14px" height="24px" />
                        <span class="luggage-text absolute-center">{{item2.bigLuggage.value}}</span>
                      </div>
                      <div @mouseleave="hidePopover()"
                          @mouseenter="showPopover(item2.quotaInfo.quotaInfoText, $event)">
                        <icon :name="item2.quotaInfo.iconName"
                              width="16px" height="16px" fill="var(--white-color)"/>
                      </div>
                    </div>
                  </div>
              </div >
              </div>
              <div v-show="getWindowSettings.compactView && checkMoreFlights(item, item2)" class="content-other-flights">
  <!--            <div v-show="!checkMoreFlights(item)" class="content-other-flights">-->
  <!--              <button class="text nowrap" @click="showOtherFlights(key)">{{ localizeList.otherFlights }}</button>-->
                <base-button
                     class="nowrap"
                     :style="[{'flex': '0 0 auto'}, {'background-color': `${item2.radioGroupItemsColor}`}]"
                     @click.stop="toggleShowGroup(key, item2.direction)"
                     size="14"
                     padding="5px 7.5px"
                     gap="10">
                     <span>
                         {{ localizeList.otherFlights }}
                     </span>
                     <icon :class="{'rotate': (showGroup[key].forward && key2 === 0) || (showGroup[key].backward && key2 === item.groupItemsFrom.length)}"
                     name="angle" width="10px" height="10px" fill="var(--white-color)" transform="rotate(0)"/>
                </base-button>
                <div class="radio-buttons">
                  <span class="nowrap">
                     {{ localizeList.departureTime+':' }}
                  </span>
                  <radio-group v-if="item2.direction === 'Forward'"
                                :items="item.groupItemsFrom"
                                :fullFlightData="item"
                                :flightData="item2"
                                :background="item2.radioGroupItemsColor"
                                v-model="selectedFlights[key].keys[0]"
                                @input="(value) => selectFlightByKey(key, value, item)"
                                radioNone
                                class="radio-other-flights"
                                @showPopover="showPopover"
                                @hidePopover="hidePopover"/>
                  <radio-group v-else
                                :items="item.groupItemsTo"
                                :fullFlightData="item"
                                :flightData="item2"
                                :background="item2.radioGroupItemsColor"
                                v-model="selectedFlights[key].keys[1]"
                                @input="(value) => selectFlightByKey(key, value, item)"
                                radioNone
                                class="radio-other-flights"
                                @showPopover="showPopover"
                                @hidePopover="hidePopover"/>
                </div>
              </div>
            </div>
          </div>
          <div class="avia-flight-buy">
            <p v-if="item.deltaPrice.amount > 0" class="text-center grey-text-small mb-3">
              {{localizeList.addCostUpper}}</p>
            <p v-if="item.deltaPrice.amount < 0" class="text-center grey-text-small mb-3">{{localizeList.discount}}</p>
            <div @mouseleave="hidePopover()"
                 @mouseenter="showPopover(getSelectText(item), $event)">
              <base-button @click="selectFlight(item, key)"
                           padding="10px 10px 8px"
                           :disabled="item.loadFlight">
                <div v-if="!item.loadFlight">
                  <div class="align-center">
                    <span>
                      {{getPlus(item.deltaPrice.amount) + correctPrice(item.deltaPrice.amount) +" "+ getCurrencyDisplayInSearch(item.deltaPrice.currency)}}
                    </span>
                    <icon name="basket" class="ml-2" width="20px" height="20px" fill="var(--white-color)" />
                  </div>
                  <p class="text-center white-text-small">{{localizeList.choose}}</p>
                </div>
                <base-loader v-else size="16" weight="5"/>
              </base-button>
            </div>
            <base-button v-if="item.hasTariffFamily"
                         class="mt-5 tariff-btn"
                         @click="showTariff(item, key)"
                         background="#4aca7f"
                         minHeight="39">
                          <span v-if="!item.loadTariff">
                              {{item.isChanged ? localizeList.tariffChangedTextUpper : localizeList.btnTextTariffChangeBaggageUpper}}
                          </span>
              <base-loader v-else size="16" weight="5"/>
            </base-button>
            <span @click="showDetails(item, key)"
                  class="blue-text-small pointer mt-5 text-center">{{localizeList.details}}</span>
            <div>
              <p class="text-time-limit flight-name nowrap text-center">
                <!--              {{localizeList.timeLimiteUpper}} <br> {{getLocalTimeLimit(item.timeLimit)}}-->
                {{localizeList.timeLimiteUpper}} <br> {{getLocalTimeLimit(item.timeLimit)}}
              </p>
            </div>
            <div v-show="baggageSearchOtherFares && item.flights[0].segments.filterLuggageValue[0]==='withoutLuggage' && item.hasTariffFamily">
              <p style="color: red"  class="text-time-limit flight-name nowrap text-center">
                {{localizeList.perhapsBaggageDifferentFareUpperP1}}
                <br>
                {{localizeList.perhapsBaggageDifferentFareUpperP2}}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div v-show="!flightList.length && getGDS && getWindowSettings.showVerticalFilters" class="empty-result">
        <h3>
          {{localizeList.noFlightsSatisfytingFiltersPartOneUpper}}
          {{resultCount}}
          {{localizeList.noFlightsSatisfytingFiltersPartTwoUpper}}
        </h3>
        <span @click="resetFilters()" class="blue-500-text pointer mt-8">{{localizeList.clearFilters}}</span>
      </div>

      </div>
    <div v-show="!flightList.length && getGDS && !getWindowSettings.showVerticalFilters" class="empty-result">
      <h3>
        {{localizeList.noFlightsSatisfytingFiltersPartOneUpper}}
        {{resultCount}}
        {{localizeList.noFlightsSatisfytingFiltersPartTwoUpper}}
      </h3>
      <span @click="resetFilters()" class="blue-500-text pointer mt-8">{{localizeList.clearFilters}}</span>
    </div>

    <pagination class="flight-pagination"
                v-if="flightList.length && getGDS"
                @change="changePage($event)"
                :current="pagination.page"
                :length="pagination.length"/>

    <avia-flight-filters @filtred="flightFiltration($event)"
                         @changeTariff="getGDSFlights($event)"
                         :set-filters="flightFilters"
                         :city-from="cityFrom"
                         :city-to="cityTo"/>

    <tariff :show="tariffStatus"
            :tariff="tariffList"
            :rate="tariffRate"
            @change="changeTariff($event)"
            @hide="tariffStatus = false"/>

    <!--Модальное окно(появляется справа)-->
    <right-modal :show="showRightModal" @toggle="showRightModal = $event">
      <!--Информация по авиа перелетам-->
      <div class="avia-flight">
        <div class="avia-flight-header">
          <icon name="flight" class="mr-8 mt-1" width="21px" height="20px" fill="var(--lighten-7-color)" />
          <div class="avia-flight-header-content">
            <h3 class="mb-3">{{localizeList.flightUpper2}}</h3>
            <p class="grey-text-small">
              {{tour.Name}} | {{getDateByFormat(tour.StartDate, "DD MMM")}}, {{tour.Duration}}
              {{localizeList.days}}
            </p>
          </div>
        </div>
        <div class="avia-flight-content">
          <div v-for="(item, key) in aviaFlightInfo.services"
               :key="key"
               class="avia-flight-card mb-10">
            <div v-for="(item2, key2) in item" :key="key2">
              <div class="card-headline flex border-b">
                <h3 class="mr-6">{{getDateByFormat(item2.departureDate, "DD MMM")}}</h3>
                <h3>{{item2.depratureCity.mtItem.name}} – {{item2.arrivalCity.mtItem.name}}</h3>
              </div>
              <div class="card-content">
                <div class="avia-info flex border-b-dash mb-10">
                  <img width="24" height="24" :class="['mr-6', {'backward-icon': item2.direction === 'Backward'}]"
                       :src="getFlightIcon(item2)"/>
                  <div class="avia-info-text">
                    <p class="grey-text-small" :title="getAirlineInfo(item2)">
                      {{ getAirlineInfo(item2) }}
                    </p>
                    <div class="align-center">
                      <div @mouseleave="hidePopover()"
                           @mouseenter="showPopover(getLuggage(item2).info, $event)"
                           class="relative mr-6">
                        <icon name="luggage" width="16px" height="15px" fill="none" />
                        <span class="absolute-center luggage-text">{{getLuggage(item2).value}}</span>
                      </div>
                      <div @mouseleave="hidePopover()"
                           @mouseenter="showPopover(getBigLuggage(item2).info, $event)"
                           class="relative mr-6">
                        <icon v-if="getLuggageType(item2) === 'big-luggage-question'"
                              name="big-luggage-question" width="14px" height="24px"/>
                        <icon v-else-if="getLuggageType(item2) === 'big-luggage-none'"
                              name="big-luggage-none" width="14px" height="24px"/>
                        <icon v-else
                              name="big-luggage" width="14px" height="24px"/>
                        <span class="luggage-text absolute-center">{{getBigLuggage(item2).value}}</span>
                      </div>
                      <icon :name="getQuotaName(item2.quotaInfo)"
                            class="mr-8"
                            width="16px" height="16px" fill="var(--white-color)"/>
                      <p v-if="getQuotaName(item2.quotaInfo) === 'aviailable'"
                         class="grey-text-small">{{localizeList.available}}</p>
                      <p v-else-if="getQuotaName(item2.quotaInfo) === 'less'"
                         class="grey-text-small">
                        {{getFreePlace(item2.quotaInfo.freePlaces)}}
                      </p>
                      <p v-else class="grey-text-small">{{localizeList.onRequest}}</p>
                    </div>
                  </div>
                </div>
                <div class="avia-time-info relative flex">
                  <div class="left-steper"></div>

                  <div class="ml-10 avia-time-info-content">
                    <p class="mb-6">
                      <span class="dark-small-bold-text">{{getTime(item2.departureDate)}}</span>
                      <span class="dark-small-bold-text mr-6 ml-6">{{item2.departureAirport.mtItem.code}}</span>
                      <span class="grey-text-small">{{item2.depratureCity.mtItem.name}}</span>
                    </p>
                    <p class="grey-text-small mb-6">
                      {{localizeList.enRoute}}
                      {{correctTime(item2.fligthTime)[0] ?
                      correctTime(item2.fligthTime)[0] +" "+
                      localizeList.hourTextUpper : ""}}
                      {{correctTime(item2.fligthTime)[1] +" "+
                    localizeList.minutesTextUpper}}
                    </p>
                    <p>
                      <span class="dark-small-bold-text">{{getTime(item2.arrivalDate)}}</span>
                      <span class="dark-small-bold-text mr-6 ml-6">{{item2.arrivalAirport.mtItem.code}}</span>
                      <span class="grey-text-small">{{item2.arrivalCity.mtItem.name}}</span>
                    </p>
                  </div>
                </div>

                <p v-if="item2.isLocalFlight" class="tour-operator-flight text-end">
                  {{localizeList.touroperatorsFlightTitleUpper}}
                </p>

                <div v-if="!isLastFlights(item, key2)" class="time-docking mb-10 mt-10">
                  <p class="grey-text-small">
                    {{localizeList.connection}}:
                    {{calcDate(item2.arrivalDate, item[key2+1].departureDate) ?
                    calcDate(item2.arrivalDate, item[key2+1].departureDate) +""+
                    getDayLocal(calcDate(item2.arrivalDate, item[key2+1].departureDate)) : ""}}

                    {{connectionTime(item, key2)[0] +" "+ localizeList.hourTextUpper}}
                    {{connectionTime(item, key2)[1] +" "+ localizeList.minutesTextUpper}}
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </right-modal>

    <page-up />
</div >
</template>

<script>
import {bus} from '../../main'
import moment from 'moment'

import {checkEquality, fullCopy, getLocalTimeLimit} from '../../plugins/methods'

import * as typesGlobal from '@/stores/types'
import * as typesBasket from '@/stores/modules/basket/types'

import pagination from "../baseComponents/pagination";
import radioGroup from "../baseComponents/baseRadioGroup";
import aviaFlightFilters from "./aviaFlightFilters";
import aviaFlightVerticalFilters from './aviaFlightVerticalFilters.vue'
import aviaFlightInfo from "./aviaFlightInfo";
import tariff from "./tariff";
import pageUp from '../baseComponents/pageUp'

export default {
  name: "avia-flight",
  components: {
    "pagination": pagination,
    "avia-flight-filters": aviaFlightFilters,
    "avia-flight-vertical-filters": aviaFlightVerticalFilters,
    "avia-flight-info": aviaFlightInfo,
    "tariff": tariff,
    "radio-group" : radioGroup,
    "page-up": pageUp
  },
  data() {
    return {
      API_ORIGIN: this.$store.getters['getApiOrigin'],
      PATH: this.$store.getters['getPath'],
      pagination: {
        length: 1,
        page: 1
      },
      flightList: [],
      cashFirstResults: [],
      showRightModal: false,
      automaticFlightSelection: false,
      baggageSearchOtherFares:false,
      automaticFlightSelectionStatus: false,
      automaticFlightSelectionIndex: 0,
      aviaFlightInfo: {
        services: []
      },
      flightFilters: {},
      sortItems: [
        {
          name: "btnTextSortCheapUpperTitlesUpper",
          value: "cheap",
          isChecked: false,
        },
        {
          name: "btnTextSortFastUpperTitleUpper",
          value: "fast",
          isChecked: false,
        },
        {
          name: "btnTextSortOptimalUpperTitleUpper",
          value: "optimal",
          isChecked: false,
        }
      ],
      mainInfoText: "",
      getGDS: false,
      tariffStatus: false,
      tariffList: [],
      tariffRate: "",
      chooseTariffKey: -1,
      Rate: {},
      cityFrom: "",
      cityTo: "",
      showGroup: [],
      selectedFlights: [],
      showAllFlights: false,
    }
  },
  props: {
    tour: {
      type: Object,
      default: () => {
      }
    },
    selectedFlight: {
      type: Array,
      default: () => {
      }
    },
    openOfMounted: {
      type: Boolean,
      default: false
    },
    flightChanged: {
      type: Boolean,
      default: false
    },
    tariffChanged: {
      type: String,
      default: null
    },
  },
  computed: {
    getWindowSettings() {
      return window.settings;
    },
    tourInfo() {
      return this.$store.getters['basket/getTour']
    },
    resultCount() {
      return this.$store.getters['basket/getResultCount'] || 0
    },
    flightListPresent() {
      let copyList = fullCopy(this.flightList);
      let result = copyList.map((x) => {
        let item = null

        x.group.forEach((_, i2) => {
          if (item === null) {
            item = this.flightsByKey(x, i2)
            item.selectedFlight = 0
          } else {
            item.flights = [...item.flights, ...this.flightsByKey(x, i2).flights]
          }
        })

        item.flights = [...item.flights].sort((a, b) =>
          a.direction > b.direction ? -1 : a.direction < b.direction ? 1 : 0)

        return item
      })
      result = result.map(x => {
        const helper = [];
        x.flights = x.flights.filter(x2 => {
          const json = JSON.stringify(x2)
          if (helper.includes(json)) return false
          helper.push(json)
          return true
        })

        return x
      })

      result = result.map(x => {
        x.groupItemsFrom = []
        x.groupItemsTo = []
        x.flights.forEach((x2, i2) => {
          if (x2.direction === "Forward"){
            x.groupItemsFrom.push({text: this.getTime(x2.departureDate), value: i2})
            return
          }
          x.groupItemsTo.push({text: this.getTime(x2.departureDate), value: i2})
        })
        return x
      })

      return result
    }
  },
  created() {
    bus.$on("calculate-for-flight", data => {
      bus.$emit("page-load", false);
      this.flightList = this.flightList.map((x) => {
        x.loadFlight = false;
        return x
      });
      if (data.hasRealCourses==false)
      {
        alert(this.localizeList.failedUpdateFlightRemoteProviderExchangeRates);
        bus.$emit("basket-flight", false);
        return;
      }
      if (!data.autoSelect) {
        bus.$emit("basket-flight", false);
      } else {
        if (this.automaticFlightSelection && this.automaticFlightSelectionStatus) {
          this.automaticFlightSelectionStatus = false;
          this.automaticFlightSelectionIndex++;
          this.automaticSelectFlight()
        } else {
          alert(this.localizeList.warningCouldNotActualizeFlightOrHotelPriceFromRemoteSystemUpper)
        }
      }
    })
  },
  mounted() {
    bus.$emit("page-load", true);
    this.$nextTick(() => {
      bus.$emit("page-load-text", this.localizeList.captionTextWaitingFirstPartPeriodUpper);
    })
    this.getGDSFlights(this.tariffChanged);
  },
  methods: {
    isLastFlights(items, key){
      const lastForwardFlight = items.findLastIndex(el => el.direction === "Forward")
      const lastBackwardFlight = items.findLastIndex(el => el.direction === "Backward")
      return (lastForwardFlight === key) || (lastBackwardFlight === key)
    },
    checkShowGroupByDirection(key, direction) {
      return this.showGroup[key][direction.toLowerCase()]
    },
    checkShowGroup(key) {
      let result = "not-active"
      if (this.showGroup[key].forward && this.showGroup[key].backward) result = "all-active"
      else if (this.showGroup[key].forward && !this.showGroup[key].backward) result = "active-forward"
      else if (!this.showGroup[key].forward && this.showGroup[key].backward) result = "active-backward"
      return result
    },
    hasBackward(item) {
      return item.flights.some(x => x.direction === "Backward")
    },
    checkMoreFlights(item, item2) {
      return item2.direction === 'Forward' && item.groupItemsFrom.length > 1 || item2.direction === 'Backward' && item.groupItemsTo.length > 1
    },
    showMoreFlightsBtn(item, item2, key, key2) {
      const isShow = !this.showGroup[key][item2.direction.toLowerCase()]
      const hasBackward = item.flights.some(x => x.direction === "Backward")
      const hasNotMoreFlights = hasBackward && item.flights.length < 3 || !hasBackward && item.flights.length === 1

      return isShow && key2 === 0 || !isShow && !hasNotMoreFlights && item2.direction === "Forward"
    },
    getCountFlights(flights) {
      this.showGroup = []
      this.selectedFlights = []
      for (let i = 0; i < flights.length; i++) {
        const forward = flights[i].flights.find(x => x.direction === 'Forward').allSegments
        const backwardIndex = flights[i].flights.map(x => x.direction).indexOf('Backward')
        const backward = flights[i].flights.find(x => x.direction === 'Backward')?.allSegments || []
        if(this.getWindowSettings.compactView) {
         this.showGroup.push({forward: false, backward: false})
        }else {
         this.showGroup.push({forward: true, backward: true})
        }
        this.selectedFlights.push({
          keys: [0, backwardIndex],
          flights: [forward, backward]
        })
      }
    },
    toggleShowGroup(key, direction) {
      const currentShowGroup = this.showGroup[key]
      if (direction === 'Backward') {
        currentShowGroup.backward = !currentShowGroup.backward
      } else {
        currentShowGroup.forward = !currentShowGroup.forward
      }
      this.$set(this.showGroup, key, currentShowGroup)
    },
    toggleShowGroupAll() {
      this.showAllFlights = !this.showAllFlights;
      this.showGroup.forEach((item) => {
      if(item.forward !== this.showAllFlights) item.forward = !item.forward;
      if(item.backward !== this.showAllFlights) item.backward = !item.backward;
      })
    },
    selectFlightByKey(key1, key2, item) {
      const selectedKeys = this.selectedFlights[key1].keys
      const selectedFlights = this.selectedFlights[key1].flights
      const index = item.flights[key2].direction === 'Forward' ? 0 : 1
      selectedFlights[index] = item.flights[key2].allSegments
      selectedKeys[index] = key2

      this.$set(this.selectedFlights, key1, {keys: selectedKeys, flights: selectedFlights})
    },
    flightsByKey(item, index) {
      const groupItemsFrom = []
      const groupItemsTo = []
      item.group.forEach((x2, i2) => {
        const timeFrom = x2.flights[0].segments[0].departureDate
        const timeTo = x2.flights[0].segments[0].arrivalDate

        let find = groupItemsFrom.find(x3 => x3.text === this.getTime(timeFrom))
        if (!find) groupItemsFrom.push({text: this.getTime(timeFrom), value: i2})

        groupItemsTo.push({text: this.getTime(timeTo), value: i2})
      })

      const newFlights = []
      const flightsFrom = []
      const flightsProgressFrom = {
        items: [],
        fligthTime: 0
      }
      const flightsTo = []
      const flightsProgressTo = {
        items: [],
        fligthTime: 0
      }
      let minTimeLimit = ''
      item.group[index].flights.forEach((x2) => {
        x2.segments.forEach(x3 => {
          const timeLimit = x3.timeLimit

          if (x3.direction === 'Forward') {
            const time = flightsFrom.at(-1)?.connectionTime || 0
            flightsFrom.push(x3)

            flightsProgressFrom.items.push({
              time: this.getTimeDifference(time),
              code: x3.departureAirport.mtItem.code,
            })
            flightsProgressFrom.fligthTime += x3.fligthTime + x3.connectionTime
            minTimeLimit = timeLimit
          } else {
            const time = flightsTo.at(-1)?.connectionTime || 0
            flightsTo.push(x3)

            flightsProgressTo.items.push({
              time: this.getTimeDifference(time),
              code: x3.departureAirport.mtItem.code,
            })
            flightsProgressTo.fligthTime += x3.fligthTime + x3.connectionTime
          }
          minTimeLimit = minTimeLimit < timeLimit ? minTimeLimit : timeLimit
        })
      })

      flightsProgressFrom.fligthTime = this.getTimeDifference(flightsProgressFrom.fligthTime)
      flightsProgressTo.fligthTime = this.getTimeDifference(flightsProgressTo.fligthTime)

      // Push last progress item
      flightsProgressFrom.items.push({
        code: flightsFrom.at(-1).arrivalAirport.mtItem.code,
      })
      if (flightsTo.length) flightsProgressTo.items.push({
        code: flightsTo.at(-1).arrivalAirport.mtItem.code,
      })
      let luggageFrom = {
        value: Infinity,
        info: ''
      }
      let bigLuggageFrom = {
        value: Infinity,
        info: ''
      }
      let luggageTypeFrom = ""
      let quotaInfoFrom = {
        iconName: '',
        text: ''
      }
      // let timeOnRoute = ""
      let airlineServicesFrom = []
      flightsFrom.forEach(x2 => {
        if (!x2) return

        const luggage = this.getLuggage(x2)
        const luggageMin = +luggage.value < +luggageFrom.value ? luggage : luggageFrom
        luggageFrom = {
          value: luggageMin.value,
          info: luggageMin.info
        }
        const bigLuggage = this.getBigLuggage(x2)
        const bigLuggageMin = +bigLuggage.value < +bigLuggageFrom.value ? bigLuggage : bigLuggageFrom
        bigLuggageFrom = {
          value: bigLuggageMin.value,
          info: bigLuggageMin.info
        }
        luggageTypeFrom = this.getLuggageType(x2)

        const iconName = this.getQuotaNameBySegment(x2)
        const quotaInfoText = this.getQuotaNameBySegment(x2, true)

        const minQuotaInfoIndex = this.getMinQuotaInfo(iconName, quotaInfoFrom.iconName)
        const iconNameMin = minQuotaInfoIndex === 0 ? iconName : quotaInfoFrom.iconName
        const quotaInfoTextMin = minQuotaInfoIndex === 0 ? quotaInfoText : quotaInfoFrom.quotaInfoText
        quotaInfoFrom = {
          iconName: iconNameMin,
          quotaInfoText: quotaInfoTextMin
        }
        airlineServicesFrom.push(x2.airline.mtItem.id)
      })
      const radioGroupItemsFromColor = "#93c8fa"
      const radioGroupItemsFromSelected = 0
      airlineServicesFrom = [...new Set(airlineServicesFrom)]

      let luggageTo = {
        value: Infinity,
        info: ''
      }
      let bigLuggageTo = {
        value: Infinity,
        info: ''
      }
      let luggageTypeTo = ""
      let quotaInfoTo = {
        iconName: '',
        text: ''
      }
      let airlineServicesTo = []
      flightsTo.forEach(x2 => {
        if (!x2) return

        const luggage = this.getLuggage(x2)
        const luggageMin = +luggage.value < +luggageTo.value ? luggage : luggageTo
        luggageTo = {
          value: luggageMin.value,
          info: luggageMin.info
        }
        const bigLuggage = this.getBigLuggage(x2)
        const bigLuggageMin = +bigLuggage.value < +bigLuggageTo.value ? bigLuggage : bigLuggageTo
        bigLuggageTo = {
          value: bigLuggageMin.value,
          info: bigLuggageMin.info
        }
        luggageTypeTo = this.getLuggageType(x2)

        const iconName = this.getQuotaNameBySegment(x2)
        const quotaInfoText = this.getQuotaNameBySegment(x2, true)

        const minQuotaInfoIndex = this.getMinQuotaInfo(iconName, quotaInfoTo.iconName)
        const iconNameMin = minQuotaInfoIndex === 0 ? iconName : quotaInfoTo.iconName
        const quotaInfoTextMin = minQuotaInfoIndex === 0 ? quotaInfoText : quotaInfoTo.quotaInfoText
        quotaInfoTo = {
          iconName: iconNameMin,
          quotaInfoText: quotaInfoTextMin
        }
        airlineServicesTo.push(x2.airline.mtItem.id)
      })
      const radioGroupItemsToColor = "#83d1a4"
      const radioGroupItemsToSelected = 1
      airlineServicesTo = [...new Set(airlineServicesTo)]

      newFlights.push({
        luggage: luggageFrom,
        bigLuggage: bigLuggageFrom,
        luggageType: luggageTypeFrom,
        quotaInfo: quotaInfoFrom,
        progress: flightsProgressFrom,
        segments: flightsFrom[0],
        allSegments: flightsFrom,
        direction: flightsFrom[0].direction || "",
        departureDate: flightsFrom[0].departureDate,
        departureCity: flightsFrom[0].depratureCity.mtItem.name,
        arrivalDate: flightsFrom.at(-1).arrivalDate,
        arrivalCity: flightsFrom.at(-1).arrivalCity.mtItem.name,
        radioGroupItemsSelected: radioGroupItemsFromSelected,
        radioGroupItemsColor: radioGroupItemsFromColor,
        selectedFlight: 0,
        groupItems: groupItemsFrom,
        airlineServices: airlineServicesFrom,
      })
      if (flightsTo.length) {
        newFlights.push({
          luggage: luggageTo,
          bigLuggage: bigLuggageTo,
          luggageType: luggageTypeTo,
          quotaInfo: quotaInfoTo,
          progress: flightsProgressTo,
          segments: flightsTo[0],
          allSegments: flightsTo,
          direction: flightsTo[0].direction || "",
          departureDate: flightsTo[0].departureDate,
          departureCity: flightsTo[0].depratureCity.mtItem.name,
          arrivalDate: flightsTo.at(-1).arrivalDate,
          arrivalCity: flightsTo.at(-1).arrivalCity.mtItem.name,
          radioGroupItemsSelected: radioGroupItemsToSelected,
          radioGroupItemsColor: radioGroupItemsToColor,
          selectedFlight: 0,
          groupItems: groupItemsTo,
          airlineServices: airlineServicesTo,
        })
      }

      const allFlights = [...item.group[index].flights]
      const flights = [...newFlights]

      item = {
        ...item,
        allFlights,
        flights
      }

      return item
    },
    showOtherFlights(key) {
      console.log(key)
    },
    getCurrentFormatTime(h, m) {
      return h + this.localizeList.hourTextUpper + " " + m + this.localizeList.minutesTextUpper
    },
    getSegments(flights) {
      return flights
        .map(x => x.segments)
        .flat(1)
        .sort((a, b) => {
          if (a.departureDate > b.departureDate) return 1;
          else if (a.departureDate < b.departureDate) return -1;
          return 0;
        })
    },
    getAirlineInfo(item) {
      const tariff = item.tariff.mtItem?.name || item.tariff.gdsItem.name;
      return `${item.airline.mtItem.name} • ${tariff} • ${item.aircraft.mtItem.name} • ${this.localizeList.flightUpper} ${item.flightNumber}`
    },
    getLocalTimeLimit(str) {
      return getLocalTimeLimit(str)
    },
    getCurrencyDisplayInSearch(code) {
      let allRate = this.$store.getters['getCurrency'];
      let rate = allRate.find(x => x.Code === code);

      return this.$store.getters['getCurrencyDisplayBySettings'](rate);
    },
    correctPrice(val) {
      return parseFloat(val) ? Math.ceil(val) : 0
    },
    getPlus(num) {
      return num < 0 ? "" : "+"
    },
    getSelectText(item) {
      return `${this.localizeList.selectFlightsUpper} <span class="nowrap">${this.getPlus(item.deltaPrice.amount)}${this.correctPrice(item.deltaPrice.amount)} ${this.getCurrencyDisplayInSearch(item.deltaPrice.currency)}</span>`
    },
    selectFlight(item, key) {
      bus.$emit("page-load", true);

      const parent = {...item}
      let selectedItem = item

      // this.flightList = this.flightList.map((x, i) => {
      //   x.loadFlight = i === key;
      //   return x
      // });

      item.group.forEach(x => {
        let forward = []
        let backward = []
        x.flights.forEach(x2 => {
          x2.segments.forEach(x3 => {
            if (x3.direction === 'Forward') {
              forward.push(x3)
              return
            }
            backward.push(x3)
          })
      })
          const selectedFlights = this.selectedFlights[key].flights
          const hasForward = checkEquality(forward, selectedFlights[0])
          const hasBackward = checkEquality(backward, selectedFlights[1])
          if (
            hasForward && hasBackward
          ) selectedItem = x
        })

      const timeLimit = selectedItem.flights[0].segments[0].timeLimit; 
      const direction = [];
      const fligthTime = [];
      const carryOnAndBaggage = [];
      const flights = selectedItem.flights.map(x => {
        let res = JSON.parse(JSON.stringify(x));
        res.segments.forEach(x2 => {
          carryOnAndBaggage.push([x2.caryyOn[0], x2.baggageRestriction[0]]);
          direction.push(res.direction);
          fligthTime.push(x2.fligthTime);
        })
        delete res.segments[0].timeLimit;
        delete res.segments[0].transferValue;
        delete res.segments[0].isLocalFlight;
        delete res.segments[0].fligthTime;
        delete res.segments[0].filterLuggageValue;

        return res
      });

      const hasLuggage = item.flights.every(x => {
        const match = x.bigLuggage.info.match(/\d+/);
        return match ? parseInt(match[0]) > 0 : false;
      });

      const sendData = {
        flights,
        tourDate: this.tour.StartDate
      };
      this.$store.dispatch("basket/" + typesBasket.A_REBUILD_FLIGHT, sendData)
        .then(res => {
          const depAirport = res.data.flights[0].flightsPlains[0].DepartureAirport.Key;
          const arrAirport = res.data.flights[res.data.flights.length - 1].flightsPlains[0].ArrivalAirport.Key;
          const selectedDepAirport = this.selectedFlight[0].airportFrom;
          const selectedArrAirport = this.selectedFlight[this.selectedFlight.length - 1].airportTo;

          const depAirportChanged = depAirport !== selectedDepAirport;
          const arrAirportChanged = arrAirport !== selectedArrAirport;

          const arrivalAirportForwardDirectionCode = item.allFlights.filter(x => x.segments[0].direction === 'Forward').at(-1)?.segments.at(-1).arrivalAirport.mtItem.code;
          const departureAirportBackwardDirection = item.allFlights.filter(x => x.segments[0].direction === 'Backward')[0]?.segments.at(-1).departureAirport.mtItem.code;
          const arrivalForwardAirportChanged = arrivalAirportForwardDirectionCode ?arrivalAirportForwardDirectionCode !== this.selectedFlight[0].airportTo : false;
          const departureBackwardAirportChanged = departureAirportBackwardDirection ? departureAirportBackwardDirection !== this.selectedFlight.at(-1).airportFrom : false;

          const text = 
         `${this.localizeList.drawYourAttention}
${depAirportChanged || arrAirportChanged ? this.localizeList.changedAirportsMessage : ''}
${arrivalForwardAirportChanged || departureBackwardAirportChanged ? this.localizeList.changedArrivalAirportMessage : ''}
${!hasLuggage ? this.localizeList.changedNoLuggageMessage : ''}`;

          if (depAirportChanged || arrAirportChanged || !hasLuggage) alert(text);

          const arrivalAirportOneDirectionDate = this.selectedFlights[key].flights[0].at(-1).arrivalDate;
          const hotels = this.tour.Services.filter(x => x.SvKey === 3);
          const beginDateHotelTime = hotels[0].BeginDateTime;
          const beginDateDay = moment(beginDateHotelTime).startOf('day');
          const departureDateDay = moment(arrivalAirportOneDirectionDate).startOf('day');
          const differenceInDays = Math.abs(departureDateDay.diff(beginDateDay, 'days'));

          if (beginDateHotelTime < arrivalAirportOneDirectionDate && differenceInDays) {
            const data = [{
                data: res.data,
                parent: parent,
                timeLimit,
                direction,
                fligthTime,
                carryOnAndBaggage
              }, {
                differenceInDays,
                mode: "decrease",
                arrivalAirportOneDirectionDate
              }];
              this.$emit("changeFlight", data);
              bus.$emit("page-load", false);

              return
          } else if (beginDateHotelTime > arrivalAirportOneDirectionDate && differenceInDays) {
            const data = [{
                data: res.data,
                parent: parent,
                timeLimit,
                direction,
                fligthTime,
                carryOnAndBaggage
              }, {
                differenceInDays,
                mode: "increase",
                arrivalAirportOneDirectionDate
              }];
              this.$emit("changeFlight", data);
              bus.$emit("page-load", false);

              return
          }

          bus.$emit("change-flight", { 
            data: res.data,
            parent: parent,
            timeLimit,
            direction,
            fligthTime,
            carryOnAndBaggage,
            dataModal: {
              arrivalAirportOneDirectionDate: arrivalAirportOneDirectionDate
            }
          });
        })
        // .catch(() => {
        //     bus.$emit("page-load", false);
        // })
    },
    changeTariff(item) {
      const baggageSearchOtherFares=this.baggageSearchOtherFares;
      this.flightList = this.flightList.map((x, i) => {
        x.isChanged = i === this.chooseTariffKey;

        if (i === this.chooseTariffKey) {
          x.flights = x.flights.map(x2 => {
            x2.remotePriceSource.flightId = item.flightId
            return x2
          })

          /* Меняем цену */
          x.deltaPrice.amount += item.deltaPrice;
          x.flights[0].commonPrice = item.price;

          /* Меняем багаж */
          let carryOn = item.universalParametrs[0].find(x2 => x2.code === "carry_on");
          let baggage = item.universalParametrs[0].find(x2 => x2.code === "baggage");
          let baggageStatus=baggage.status;
          if (carryOn) {
            carryOn = carryOn.text.split(":")[1];
            x.flights = x.flights.map(x2 => {
              x2.segments[0].caryyOn = [carryOn];
              return x2
            })
          }
          if (baggage) {
            baggage = baggage.text.split(":")[1];
            x.flights = x.flights.map(x2 => {
              x2.segments[0].baggageRestriction = [baggage];
              return x2
            })

            if (baggageSearchOtherFares)
            {
              if (baggageStatus===1)
              {
                x.flights[0].segments[0].filterLuggageValue[0]="withLuggage";
              }
              else
              {
                x.flights[0].segments[0].filterLuggageValue[0]="withoutLuggage";
              }
            }
          }
        }
        return x
      });
    },
    showTariff(item, key) {
      this.chooseTariffKey = key;
      this.flightList = this.flightList.map((x, i) => {
        x.loadTariff = i === key;
        return x
      });
      this.tariffRate = item.deltaPrice.currency;
      const lang = localStorage.getItem("localize");
      let sendParams = {
        currency: item.deltaPrice.currency,
        flightId: item.allFlights[0].remotePriceSource.flightId,
        languageCode: lang,
        param: null,
        passengers: null,
        price: item.allFlights[0].commonPrice,
        providerId: item.allFlights[0].remotePriceSource.providerId
      }
      this.$store.dispatch("basket/" + typesBasket.A_GET_TARIFF, sendParams)
        .then(res => {
          this.tariffList = res.data.tariffSequencies;
          this.tariffStatus = true
        })
        .catch(() => {
          alert(this.localizeList.noFaresAvailableFlight)
        })
        .finally(() =>{
          this.flightList = this.flightList.map((x) => {
            x.loadTariff = false;
            return x
          });
        })
    },
    getDateByFormat(date, format) {
      return moment(date).format(format)
    },
    resetFilters() {
      bus.$emit("reset-avia-fligth-filters", true)
    },
    changeSort(key) {
      let value = null;
      this.sortItems = this.sortItems.map((x, i) => {
        if (i === key) {
          x.isChecked = true;
          value = x.value
        } else {
          x.isChecked = false
        }
        return x
      });
      bus.$emit("sort-avia-flight", value);
    },
    getGDSFlights(tariff = null) {
      const langueCode = localStorage.getItem("localize");
      let baseFlightsParams = this.tourInfo.tour.Services.filter(x => x.SvKey === 1);
      let flightsSource = [];
      let commission = false;

      baseFlightsParams = baseFlightsParams.map((x, i) => {
        const selectedFlight = this.selectedFlight
          .find((x2, i2) => i === i2).flightClassSelected.allData;

        let source = {
          flightDateTimeLimitationInterval: {
            finishLimitation: null,
            startLimitation: null
          },
          flightSettings: {
            patternId: x.FlightSetting.PatternId,
            serviceId: x.FlightSetting.FlightId,
            templateId: x.FlightSetting.ServiceId
          },
          flightSourceMode: x.FlightSourceMode,
          price: selectedFlight.Cost,
          quotaInfo: {
            freePlaces: selectedFlight.QuotaStatus.FreePlaces,
            isFewPlaces: selectedFlight.QuotaStatus.IsFewPlaces,
            status: selectedFlight.QuotaStatus.PlacesStatus
          },
          service: {
            cityId: x.ArrivalCity.Key,
            code: x.Flight.Key,
            countryId: x.ArrivalCountry.Key,
            day: x.Day,
            durationInNight: x.DurationInNight,
            packetId: x.PacketId,
            partnerId: selectedFlight.PartnerId,
            serviceType: x.SvKey,
            subCode1: selectedFlight.Tariff.Key,
            subCode2: x.DepartureCity.Key
          }
        }

        source.flightDateTimeLimitationInterval.startLimitation = {
          dateTimeString: x.BeginDateTime,
          serviceCode: x.Flight.Key,
          serviceType: 1
        }

        source.flightDateTimeLimitationInterval.finishLimitation = {
          dateTimeString: x.EndDateTime,
          serviceCode: x.Flight.Key,
          serviceType: 1
        }

        flightsSource.push(source)

        if (selectedFlight.IsCommission) {
          commission = true
        }
        let tariffKey = selectedFlight.Tariff.Key;
        let partnerId = selectedFlight.PartnerId;
        return {
          CityArrival: x.ArrivalCity.Key,
          FlightCode: x.Flight.Key,
          PartnerId: partnerId,
          TariffKey: tariffKey
        }
      });

      const sendData = {
        baseFlightsParams: baseFlightsParams,
        filterDeptime: ["all"],
        filterTariff: tariff || {},
        flightsSource: flightsSource,
        isCommission: commission,
        isUpdated: false,
        langueCode: langueCode,
        passengers: this.tourInfo.tourists,
        tourCurrency: this.tourInfo.tour.Rate,
        tourDate: this.tourInfo.tour.StartDate,
        tourDurationByDays: this.tourInfo.tour.Duration,
        //tourDurationByNights: this.tourInfo.tour.DurationInNight,
        tourId: this.tourInfo.tour.Key,
        isCanary: true
      }
      this.Rate = this.tourInfo.tour.Rate;
      this.$store.dispatch("basket/A_GET_GDS_FLIGHT", sendData)
        .then(res => {
          bus.$emit("GDSReady", true);
          this.cashFirstResults = JSON.parse(JSON.stringify(res.flightsSequencies));
          let pageLength = res.flightsSequencies.length / 20;
          this.pagination.length = Math.ceil(pageLength);

          // Переапределяем значение по умолчанию, если включена настрейка в туре
          if (this.tour.IndividualFlightSelection) {
            res.airTravelAdapterFilterValues.ClassAirTravelFilterValue = this.tour.FlightClass;
            res.airTravelAdapterFilterValues.ConnectionsFilterValue = this.tour.DirectsForView;
            res.airTravelAdapterFilterValues.LuggageFilterValue = this.tour.LuggageForView;
            res.airTravelAdapterFilterValues.SortFilterValue = this.tour.SortingForView;
            res.airTravelAdapterFilterValues.DepartureTimeLimit = this.tour.DepartureTimeLimit;
          }

          this.flightFilters = JSON.parse(JSON.stringify(res));

          //определяем автоматическую выборку
          this.automaticFlightSelection = res.airTravelAdapterFilterValues.AutomaticFlightSelection && this.openOfMounted;
          this.baggageSearchOtherFares=res.airTravelAdapterFilterValues.BaggageSearchOtherFares;
          bus.$emit("automaticFlightSelection", this.automaticFlightSelection);

          //применяем сортировку из настроек
          const sortValue = res.airTravelAdapterFilterValues.SortFilterValue;
          this.sortItems.map((x, i) => {
            if (x.value === sortValue) {
              this.changeSort(i)
            }
          });
          this.$nextTick(() => {
            this.createMainInfo(res);
            // this.filtreFlightList();
            bus.$emit("page-load", false);

            const showFilterAlert = window.localStorage.getItem("showFilterAlertGDS");
            if (showFilterAlert === "false") return;

            const filterBtn = {
              target: this.$refs.filterBtn
            }
            window.hideFilterAlertGDS = () => {
              this.hidePopover();
              window.localStorage.setItem("showFilterAlertGDS", "false")
            }
            const content = `
                                <div>
                                    <p>${this.localizeList.filters}</p>
                                    <span onclick="hideFilterAlertGDS()" class="blue-text-small pointer">${this.localizeList.doNotShowAgain}</span>
                                </div>
                                `;
            this.showPopover(content, filterBtn);
            setTimeout(() => {
              this.hidePopover();
            }, 5000)
          });
          this.getGDS = true;
        })
        .catch((error) => {
          if (error?.data?.Message) {
            if (error.data.Message === "Не удалось найти папку с файлом базы данных авиа GDS") {
              alert(this.localizeList.folderNotFoundUpper);
            }
            if (error.data.Message === "Не удалось найти указанный файл.") {
              alert(this.localizeList.fileNotFoundUpper);
            }
          } else {
            if (error.data.validationResult?.Errors.indexOf("NoPlaces") > -1 || error.data.validationResult?.Errors.indexOf("justNoTicketsError") > -1) {
              this.$emit("NoTicketsError",error.data.tariff);

            } else {
              let warningText = this.localizeList.warningTechnicalProblemsMessageUpper;
              warningText = warningText.replace(/{\d+}/g, '\n');
              alert(warningText);
            }
          }

          bus.$emit("basket-flight", false);
          bus.$emit("page-load", false);
        })
    },
    createMainInfo(res) {
      const data = res.flightsStartEndPointPatterns.sort((a, b) => {
        return a.departureDate > b.departureDate ? 1 : (a.departureDate < b.departureDate ? -1 : 0)
      });
      const flightFrom = data[0];
      const flightTo = data.length > 1 ? data[data.length-1] : null;
      const countryFrom = flightFrom.fromPoint.country.description;
      const cityFrom = flightFrom.fromPoint.city.description;
      const countryTo = flightFrom.toPoint.country.description;
      const cityTo = flightFrom.toPoint.city.description;

      let dateFrom = flightFrom.departureDate;
      dateFrom = dateFrom.split("T")[0].split("-").reverse().join(".");
      let dateTo = flightTo ? flightTo.departureDate : null;
      if (dateTo) {
        dateTo = dateTo.split("T")[0].split("-").reverse().join(".");
      }

      const adult = res.passengersAgeInfos.find(x => x.ageType == 0).count;
      let child = res.passengersAgeInfos.find(x => x.ageType == 1);
      let people = `${adult} ${this.localizeList.adults}`
      if (child) {
        child = child.count;
        people += `,${child} ${this.localizeList.children}`
      }

      this.cityFrom = cityFrom;
      this.cityTo = cityTo;
      this.mainInfoText = `${countryFrom} (${cityFrom}) – ${countryTo} (${cityTo}) • ${dateFrom}${(dateTo ? " – " + dateTo : "")} • ${people}`
    },
    flightFiltration(val) {
      if (!val) {
        return
      }
      this.pagination.page = 1;
      this.pagination.length = val.paginationLength;

      this.flightList = val.list.map(x => {
        x.loadTariff = false;
        x.selectedGroup = 0;
        return x
      });
    },
    filtreFlightList() {
      let params = {};
      params.page = this.pagination.page;

      this.$store.dispatch('basket/A_GET_FLIGHTS_SEQUENCIES', {
        params: params,
        changePage: true
      }).then(res => {
        this.flightList = res.list.map(x => {
          x.loadTariff = false;
          x.selectedGroup = 0;
          return x
        });
      })
    },
    changePage(page) {
      this.pagination.page = page;
      this.filtreFlightList()
      window.scrollTo(0, 0);
    },
    showDetails(item, key) {
      this.aviaFlightInfo.services = [];
      const segments = [];
      // item.allFlights.forEach(x => {
      //   x.segments
      this.selectedFlights[key].flights.forEach(x => {
        x.forEach(x2 => {
            segments.push({segment: x2, direction: x.direction})
          })
      });

      segments
        .sort((a, b) => {
          if (a.segment.departureDate > b.segment.departureDate) return 1;
          else if (a.segment.departureDate < b.segment.departureDate) return -1;
          else return 0;
        })
        .forEach((x, i, arr) => {
          if (!this.aviaFlightInfo.services.length) {
            this.aviaFlightInfo.services.push([x.segment]);
          } else {
            if (x.direction === arr[i-1].direction) {
              this.aviaFlightInfo.services[this.aviaFlightInfo.services.length - 1].push(x.segment)
            } else {
              this.aviaFlightInfo.services.push([x.segment])
            }
          }
        });

      this.showRightModal = true;
    },
    // showDetails(item) {
    //     this.aviaFlightInfo.services = [];
    //     let direction = [];
    //     item.flights.forEach(x => {
    //         x.segments.forEach(x2 => {
    //             if (!this.aviaFlightInfo.services.length) {
    //                 this.aviaFlightInfo.services.push([x2]);
    //                 direction.push(x.direction)
    //             } else {
    //                 if (x.direction === direction[0]) {
    //                     this.aviaFlightInfo.services[0].push(x2)
    //                 } else {
    //                     if (!this.aviaFlightInfo.services[1]) {
    //                         this.aviaFlightInfo.services.push([x2])
    //                     } else {
    //                         this.aviaFlightInfo.services[1].push(x2)
    //                     }
    //                 }
    //             }
    //         })
    //     });
    //     this.showRightModal = true;
    // },
    getTimeDifference(min) {
      if (!min) return '';

      const time = this.correctTime(min)
      return (time[0] ? `${time[0]}${this.localizeList.hourTextUpper} ` : '') +
        `${time[1]}${this.localizeList.minutesTextUpper}`
    },
    correctTime(min) {
      const h = ~~(min / 60);
      const m = min % 60;
      return [h, m]
    },
    connectionTime(items, key) {
      const arrival = moment(items[key].arrivalDate);
      const departure = moment(items[key + 1].departureDate);

      const duration = moment.duration(departure.diff(arrival));
      const h = ~~(duration.asHours());
      const m = ~~(duration.asMinutes());

      return [h, m - h * 60]
    },
    calcDate(item1, item2) {
      let time1 = item1.split("T")[0];
      let time2 = item2.split("T")[0];
      return this.$store.getters['calcDate'](time1, time2);
    },
    getTime(date) {
      return date.split("T")[1].slice(0, -3)
    },
    getDayLocal(day) {
      if (day == 1) {
        return this.localizeList.day
      } else if (day < 5) {
        return this.localizeList.day2
      } else {
        return this.localizeList.days
      }
    },
    getFlightInfo(item) {
      let code = item.airline.mtItem.code;
      let name = item.airline.mtItem.name;
      let number = item.flightNumber;
      return `${code} ${number} (${name})`
    },
    /*getDatePlaceInfo(item) {
      let date = item.departureDate.split("T")[0];
      date = moment(date).format("DD MMM");
      let arrival = item.arrivalAirport.mtItem.code;
      let departure = item.departureAirport.mtItem.code;
      return `${date}, ${departure} — ${arrival}`
    },*/
    getDatePlaceInfo(item) {
      let result = []
      /*let date = item.departureDate.split("T")[0];
      date = moment(date).format("DD MMM");*/
      result.push(item.arrivalAirport.mtItem.code)
      result.push(item.departureAirport.mtItem.code)
      return result;
    },
    getLuggage(item) {
      let value = item.caryyOn[0].match(/\d+ к|\d+ k/);
      if (value) {
        value = +value[0]?.[0] != 0 ? value[0].match(/\d+/)[0] : ""
      }
      let info = item.caryyOn[0];
      if (info === "HandLuggageOnly") {
        info = this.localizeList.handOnly
      }

      return {
        value: value || "",
        info: info
      }
    },
    getBigLuggage(item) {
      let value = item.baggageRestriction[0].match(/\d+ к|\d+ k/);
      if (value) {
        value = +value[0]?.[0] != 0 ? value[0].match(/\d+/)[0] : ""
      }
      let info = item.baggageRestriction[0];

      return {
        value: value || "",
        info: info
      }
    },
    getLuggageType(item) {
      let value = item.baggageRestriction[0];

      if (!value.match(/\d+/)) {
        return 'big-luggage-question'
      }
      if (value.match(/\d+/)[0] == 0) {
        return 'big-luggage-none'
      }
      if (!value.match(/\d+ к|\d+ k/)) {
        return 'big-luggage-question'
      }
      if (value.match(/\d+/)[0] !== "0") {
        return 'big-luggage'
      }
    },
    /*getQuotaNameBySegment(item, textMode = false) {
      let quota = item[0].quotaInfo;
      let res = null;

      if (quota.status === 2) {
        if (textMode) {
          res = this.localizeList.quotaHasNoPlaces
        } else {
          res = "not-aviailable"
        }
      } else if (quota.status === 4) {
        if (textMode) {
          res = this.localizeList.onRequest
        } else {
          res = "request"
        }
      } else if (quota.status === 1 && quota.freePlaces > 0) {
        if (textMode) {
          const placesLeft = quota.freePlaces === 1 ? 'placesLeft1' : (quota.freePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
          res = this.localizeList[placesLeft].replace("{}", quota.freePlaces);
        } else {
          res = "less"
        }
      } else {
        if (textMode) {
          res = this.localizeList.available
        } else {
          res = "aviailable"
        }
      }
      return res
    },*/
    getMinQuotaInfo(info1, info2) {
      const status = ['not-aviailable', 'request', 'less', 'aviailable'];
      const a = status.indexOf(info1)
      const b = status.indexOf(info2)

      if (a === -1) return 1
      if (b === -1) return 0

      return a < b ? 0 : 1
    },
    getQuotaNameBySegment(item, textMode = false) {
      let quota = item.quotaInfo;
      let res = null;

      if (quota.status === 2) {
        if (textMode) {
          res = this.localizeList.quotaHasNoPlaces
        } else {
          res = "not-aviailable"
        }
      } else if (quota.status === 4) {
        if (textMode) {
          res = this.localizeList.onRequest
        } else {
          res = "request"
        }
      } else if (quota.status === 1 && quota.freePlaces > 0) {
        if (textMode) {
          const placesLeft = quota.freePlaces === 1 ? 'placesLeft1' : (quota.freePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
          res = this.localizeList[placesLeft].replace("{}", quota.freePlaces);
        } else {
          res = "less"
        }
      } else {
        if (textMode) {
          res = this.localizeList.available
        } else {
          res = "aviailable"
        }
      }
      return res
    },
    getFreePlace(item) {
      const placesLeft = item === 1 ? 'placesLeft1' : (item < 5 ? 'placesLeft2' : 'placesLeft3');
      return this.localizeList[placesLeft].replace("{}", item);
    },
    getQuotaName(quota) {
      if (!quota) {
        return null
      }
      let res = null;
      if (quota.status === 2) {
        res = "not-aviailable"
      } else if (quota.status === 4) {
        res = "request"
      } else if (quota.status === 1 && quota.freePlaces > 0) {
        res = "less"
      } else {
        res = "aviailable"
      }
      return res
    },
    getFlightIcon(item) {
      let id
      if (item.segments) {
        id = item.segments[0].airline.mtItem.id;
      } else {
        id = item.airline.mtItem.id;
      }
      return `${this.API_ORIGIN}${this.PATH}/GetImage/GetImage?type=Airline&id=${id}&width=50&height=50`
    },
    automaticSelectFlight() {
      this.automaticFlightSelectionStatus = true;
      const index = this.automaticFlightSelectionIndex;

      if (!this.cashFirstResults[index]) {
        bus.$emit("basket-flight", false);
        return;
      }
      this.selectFlight(this.cashFirstResults[index])
    },
    toBasket() {
      if (!this.openOfMounted || this.flightChanged) {
        bus.$emit("basket-flight", false);
        return;
      }
      if (this.automaticFlightSelection) {
        let alertText = this.localizeList.closedModalFormWithRequiredFlightsWithAutomaticFlightSelectionUpper.replace("{0}", "\n");
        alert(alertText);
        this.automaticSelectFlight();
        return
      }

      let alertText = this.localizeList.closedModalFormWithRequiredFlightsUpper.replace("{0}", "\n");
      alert(alertText);
      bus.$emit("basket-flight", false);
    },
    openFilters() {
      bus.$emit("avia-flight-filters-toggle", true)
    },
    showPopover(text, e) {
      if(!e.target?.getBoundingClientRect()) return;
      let rect = e.target.getBoundingClientRect()
      let res = {
        x: rect.left + (rect.width / 2),
        y: rect.top,
        text: text,
        height: rect.height
      }
      this.$store.dispatch(typesGlobal.A_SHOW_POPOVER, res)
    },
  },
  filters: {
    getDate(val) {
      return val.split("T")[0].replaceAll("-", ".").split(".").reverse().join(".")
    },
    getTime(val) {
      let time = val.split("T")[1];
      time = time.split(":");
      time = `${time[0]}:${time[1]}`;
      return time
    }
  },
  watch: {
    flightListPresent(val) {
      this.getCountFlights(val);
      if (val && !this.getWindowSettings.compactView) {
        if(!this.showAllFlights) this.toggleShowGroupAll();
      }
    },
    tariffChanged(trf){
      this.getGDSFlights(trf);
    }
  }
}
</script>

<style scoped>
.avia-flight-out .avia-flight-out-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 17px 60px;
  background-color: var(--white-color);
  border-top: 1px solid #E0E0E0;
  border-bottom: 1px solid #E0E0E0;
}

.avia-flight-out .vertical-filters-flights {
  display: flex;  
  align-items: flex-start;
}

@media (min-width: 1920px){
  .avia-flight-out .vertical-filters-flights {
    justify-content: center;
    transform: translateX(-8%);
  }
}

.avia-flight-out .vertical-filters-flights .vertical-sidebar {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-basis: 280px;
  margin: 20px 0 30px 30px;
}

.avia-flight-out .avia-flight-out-header .to-basket {
  font-weight: 600;
  font-size: 15px;
  line-height: 18px;
  color: var(--primary-color);
  cursor: pointer;
}

.avia-flight-out .avia-flight-out-header .filters-wrap {
  display: flex;
  gap: 10px;
  align-items: center;
}

.avia-flight-out .avia-flight-out-header .filters-wrap:not(:last-child) {
  margin-right: 10px;
}

.avia-flight-out .avia-flight-out-header .show-all-button {
  display: flex;
  gap: 10px;
  align-items: center;
}

.avia-flight-out .avia-flight-out-header .show-all-button .show-all-button-text {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: var(--primary-color);
  padding-left: 10px;
}

.avia-flight-out .avia-flight-out-header .sort-title {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: var(--lighten-5-color);
}

.avia-flight-out .avia-flight-out-header .filters-wrap .filters-text {
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: var(--lighten-5-color);
  padding-left: 10px;
  border-left: 1px solid var(--lighten-5-color);
}

.rotate {
  transform: rotate(180deg);
}

.avia-flight-out .avia-flight-group {
  padding: 20px 60px;
  display: grid;
  grid-gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.vertical-filters-flights .avia-flight-group {
  flex-basis: 1100px;
  flex-shrink: 1;
  max-width: none;
  margin: 0;
}

.avia-flight-out .short-info {
  display: flex;
  padding: 30px 60px 0;
  text-align: center;
  justify-content: center;
}

.avia-flight-out .short-info .short-info-title {
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  color: var(--dark-1-color);
}

.avia-flight-out .short-info .short-info-text {
  font-size: 15px;
  line-height: 19px;
  color: #727272;
}

.avia-flight-out .avia-flight-group .avia-flight-item {
  background: var(--white-color);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  display: grid;
  grid-template-columns: 1fr minmax(150px, auto);
}

.avia-flight-out .avia-flight-group .avia-flight-item.change {
  background: #f7f7f7;
}

/* .avia-flight-out .avia-flight-group .avia-flight-item.change /deep/ .flight-info-content .avia-flight-item .circle {
  box-shadow: 0 0 0 11px #f7f7f7;
} */

.avia-flight-out .avia-flight-group .avia-flight-content-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.avia-flight-out .avia-flight-group .avia-flight-content {
  padding: 15px 16px;
  position: relative;
  overflow: unset;
}

.avia-flight-out .avia-flight-group .avia-flight-content:hover {
  cursor: pointer;
}

.avia-flight-out .avia-flight-group .avia-flight-content.empty-backward {
  height: 100%;
}
.avia-flight-out .avia-flight-group .avia-flight-content.forward {
  /*display: none;*/
}
.avia-flight-out .avia-flight-group .avia-flight-content.forward:first-child {
  display: block;
  position: relative;
}
.avia-flight-out .avia-flight-group .avia-flight-item .avia-flight-content::after {
  content: '';
  width: 12px;
  height: 14px;
  background-color: #f2f2f2;
  position: absolute;
  /*top: calc(100% - 7px);*/
  left: -1px;
  z-index: 1;
  border-radius: 0 7px 7px 0;
  box-shadow: 0 2px 6px rgb(0 0 0 / 8%) inset;
  display: none;
}
.avia-flight-out .avia-flight-group .avia-flight-item:not(.all-active, .active-forward) .avia-flight-content.forward.selected:not(.empty-backward)::after {
  display: block;
  top: calc(100% - 7px);
}
.avia-flight-out .avia-flight-group .avia-flight-item.all-active .avia-flight-content.first-backward:not(.empty-backward)::after,
.avia-flight-out .avia-flight-group .avia-flight-item.active-forward .avia-flight-content.backward.selected:not(.empty-backward)::after {
  display: block;
  top: -7px;
}

.avia-flight-out .avia-flight-group .avia-flight-content .color-content {
  width: 12px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.avia-flight-out .avia-flight-group .avia-flight-content .color-content.primary {
  background-color: #93c8fa;
  border-radius: 0 0 0 0;
}
.avia-flight-out .avia-flight-group .avia-flight-content .color-content.green {
  background-color: #83d1a4;
  border-radius: 0 0 0 0;
}
.avia-flight-out .avia-flight-group .avia-flight-item.not-active .avia-flight-content.forward.selected.empty-backward .color-content.primary {
  border-radius: 5px 0 0 5px;
}
.avia-flight-out .avia-flight-group .avia-flight-item:not(.all-active, .active-forward) .avia-flight-content.selected.forward .color-content.primary,
.avia-flight-out .avia-flight-group .avia-flight-item.active-forward .avia-flight-content.forward:first-child .color-content.primary,
.avia-flight-out .avia-flight-group .avia-flight-item.all-active .avia-flight-content.forward:first-child .color-content.primary {
  border-radius: 5px 0 0 0;
}
.avia-flight-out .avia-flight-group .avia-flight-item:not(.all-active, .active-backward) .avia-flight-content.selected.backward .color-content.green,
.avia-flight-out .avia-flight-group .avia-flight-item.active-backward .avia-flight-content.backward:last-child .color-content.green,
.avia-flight-out .avia-flight-group .avia-flight-item.all-active .avia-flight-content.backward:last-child .color-content.green {
  border-radius: 0 0 0 5px;
}

.avia-flight-out .avia-flight-group .avia-flight-content.selected {
  cursor: default;
}

.avia-flight-out .avia-flight-group .avia-flight-content.forward-selected {
  background: #f2fafc;
}

.avia-flight-out .avia-flight-group .avia-flight-content.backward-selected {
  background: #ecf5f3;
}

.avia-flight-out .avia-flight-group .avia-flight-content .flex-content {
  display: flex;
  flex-direction: column;
}

.avia-flight-out .avia-flight-group .avia-flight-content .flex-content .departure-title {
  display: flex;
  column-gap: 10px;
  font-size: 15px;
  color: #ffffff;
  line-height: 1;
  margin: -15px -17px 5px -16px;
  padding-left: 12px;
  height: 30px;
  align-items: center;
  border-radius: 6px 0 0 0;
}

.avia-flight-out .avia-flight-group .avia-flight-content .flex-content .departure-title.forwardColor {
  background-color: #93c8fa;
}

.avia-flight-out .avia-flight-group .avia-flight-content .flex-content .departure-title.backwardColor {
  background-color: #83d1a4;
}

.avia-flight-out .avia-flight-group .avia-flight-content .flex-content .info-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.avia-flight-out .avia-flight-group .avia-flight-content .arrival-info {
  display: flex;
}

.avia-flight-out .avia-flight-group .avia-flight-content .departure-info {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
  justify-content: space-between;
}

.avia-flight-out .avia-flight-group .avia-flight-content .departure-info .img-wrap {
  width: 50px;
}

.avia-flight-out .avia-flight-group .avia-flight-content .departure-info .img-wrap img {
  transform: translateY(-50%);
}

.avia-flight-out .avia-flight-group .avia-flight-content .info-flight .text-info {
  text-align: center;
}

.avia-flight-out .avia-flight-group .avia-flight-content .info-flight .text-info .time {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 5px;
}

.avia-flight-out .avia-flight-group .avia-flight-content .info-flight .flights-number {
  padding: 5px 0;
  text-align: left;
  font-weight: bold;
  font-size: 12px;
}

.avia-flight-out .avia-flight-group .avia-flight-content .info-flight .text-info .country {
  font-weight: bold;
  color: #727272;
  font-size: 12px;
  margin-bottom: 5px;
}

.avia-flight-out .avia-flight-group .avia-flight-content .info-flight .text-info .progress-flight-time {
  position: absolute;
  left: 60px;
  top: 4px;
  white-space: nowrap;
  z-index: 1;
  font-size: 14px;
  text-transform: lowercase;
}

.avia-flight-out .avia-flight-group .avia-flight-content .info-flight .text-info .data {
  color: #727272;
  font-size: 11px;
}

.avia-flight-out .avia-flight-group .flight-info-content {
  width: 63%;
}

.avia-flight-out .avia-flight-group .avia-flight-content .content-other-flights {
  background-color: #f2f2f2;
  padding: 6px 15px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  margin-top: 6px;
  gap: 15px;
  /*display: none;*/
}

.avia-flight-out .avia-flight-group .avia-flight-content .content-other-flights .radio-buttons{
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.avia-flight-out .opacity-0 {
  opacity: 0;
}

.avia-flight-out .avia-flight-group .avia-flight-content .content-other-flights .text {
  /*margin-right: 15px;*/
  cursor: pointer;
  color: var(--primary-color);
  border: none;
}
.avia-flight-out .avia-flight-group .avia-flight-item.all-active .avia-flight-content.forward:not(.first-forward) .content-other-flights,
.avia-flight-out .avia-flight-group .avia-flight-item.all-active .avia-flight-content.backward:not(.first-backward) .content-other-flights,
.avia-flight-out .avia-flight-group .avia-flight-item.active-forward .avia-flight-content.forward:not(.first-forward) .content-other-flights,
.avia-flight-out .avia-flight-group .avia-flight-item.active-backward .avia-flight-content.backward:not(.first-backward) .content-other-flights {
  display: none;
}

.avia-flight-out .avia-flight-group .avia-flight-content:not(:last-child)::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 52px;
  right: 0;
  height: 1px;
  background-color: var(--lighten-4-color);
}
.avia-flight-out .avia-flight-group .avia-flight-item.not-active .avia-flight-content.forward.selected:not(.empty-backward)::before,
.avia-flight-out .avia-flight-group .avia-flight-item.all-active .avia-flight-content.forward.last-forward:not(.empty-backward)::before,
.avia-flight-out .avia-flight-group .avia-flight-item.active-forward .avia-flight-content.forward.last-forward:not(.empty-backward)::before,
.avia-flight-out .avia-flight-group .avia-flight-item.active-backward .avia-flight-content.forward.selected:not(.empty-backward)::before {
  content: "";
  position: absolute;
  bottom: -3px;
  left: 10px;
  right: 0;
  height: 6px;
  background-color: var(--lighten-4-color);
}

.avia-flight-out .avia-flight-group .time-info {
  min-width: 116px;
}

.avia-flight-out .avia-flight-group .time-info .time {
  font-weight: bold;
  font-size: 17px;
  line-height: 28px;
  color: var(--dark-1-color);
}

.avia-flight-out .tour-operator-flight,
.avia-flight-out .avia-flight-group .time-info .time-difference {
  font-size: 13px;
  line-height: 28px;
  color: #727272;
}

.avia-flight-out .avia-flight-group .flight-info {
  padding: 0;
}

.avia-flight-out .avia-flight-group .flight-info .flight-name {
  font-weight: 500;
  font-size: 13px;
  line-height: 28px;
  color: var(--dark-1-color);
}

.avia-flight-out .avia-flight-group .flight-info .airport-info {
  font-size: 13px;
  line-height: 28px;
  color: #727272;
  margin-right: 12px;
}

.avia-flight-out .avia-flight-group .luggage-info {
  display: flex;
  align-items: center;
  margin-left: 30px;
}

.avia-flight-out .avia-flight-group .luggage-info .luggage-text {
  font-weight: bold;
  font-size: 8px;
  line-height: 28px;
  color: var(--green-2-color);
}

.avia-flight-out .avia-flight-group .avia-flight-buy {
  padding: 18px;
  border-left: 1px solid var(--lighten-4-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: default;
  min-width: 175px;
}

.avia-flight-out .avia-flight-group .avia-flight-buy /deep/ .tariff-btn.base-button {
  font-size: 13px;
}

.avia-flight-out .avia-flight-group .avia-flight-buy .text-time-limit {
  font-size: 13px;
  margin-top: 10px;
}

.avia-flight-out .flight-pagination {
  padding: 20px 60px 30px;
}

.empty-result {
  margin: 20px 60px;
  padding: 16px;
  background: var(--lighten-6-color);
  font-size: 18px;
}

/* MODAL AVIA FLIGHT */
.basket .avia-flight {
  width: 454px;
  background-color: var(--lighten-6-color);
  height: 100%;
}

.basket .avia-flight-header {
  background-color: var(--white-color);
  padding: 20px;
  display: flex;
  box-shadow: 0 1px 2px rgba(100, 100, 100, .2);
  position: relative;
}

.basket .avia-flight-header-content h3 {
  font-weight: 500;
  font-size: 22px;
  line-height: 26px;
  color: #1D1D1D;
}

.basket .avia-flight-content {
  padding: 28px;
  overflow-y: auto;
  /*height: calc(100% - 100px);*/
  height: calc(100% - 77px);
}

.basket .avia-flight-card {
  background-color: var(--white-color);
  border-radius: 6px;
}

.basket .avia-flight-card .card-headline {
  padding: 16px 16px 12px 16px;
}

.basket .avia-flight-card .card-headline h3 {
  font-weight: bold;
  font-size: 17px;
  line-height: 38px;
  color: var(--dark-1-color);
}

.basket .avia-flight-card .card-content {
  padding: 12px 16px 20px;
}

.basket .avia-flight-card .card-content .avia-info-text {
  overflow: hidden;
}

.basket .avia-flight-card .card-content .avia-info {
  padding-bottom: 12px;
}

.basket .avia-flight-card .card-content .avia-info p {
  line-height: 20px;
}

.basket .avia-flight-card .card-content .avia-info .luggage-text {
  font-weight: bold;
  font-size: 8px;
  line-height: 28px;
  color: var(--green-2-color);
}

.basket .avia-flight-card .card-content .avia-time-info .left-steper {
  position: absolute;
  width: 1px;
  height: 80%;
  top: 10%;
  left: 6px;
  background-color: var(--lighten-7-color);
}

.basket .avia-flight-card .card-content .avia-time-info .left-steper:before,
.basket .avia-flight-card .card-content .avia-time-info .left-steper:after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--lighten-7-color);
  left: -3px;
}

.basket .avia-flight-card .card-content .avia-time-info .left-steper:before {
  top: 0;
}

.basket .avia-flight-card .card-content .avia-time-info .left-steper:after {
  bottom: 0;
}

.basket .avia-flight-card .card-content .time-docking {
  background-color: var(--lighten-6-color);
  padding: 12px 16px;
}

@media (max-width: 1300px) {
  .avia-flight-out .avia-flight-group {
    grid-template-columns: 1fr;
  }
}
</style>
